<template>

  <div>
    <md-toolbar class="md-primary">
      <h3 class="md-title" style="flex: 1">Magazzini</h3>
      <md-button class="md-icon-button" @click="exportData()">
          <md-icon>file_download</md-icon>
      </md-button>
      <md-button class="md-icon-button" @click="printList()">
          <md-icon>print</md-icon>
      </md-button>
      <downloadCsv v-if="null != jsonData" :data="jsonData" name="magazzino.csv" style="display:none" ref="dlMagazzinoBtn"></downloadCsv>
    </md-toolbar>
    <md-card style="margin-bottom: 20px;" class="filtri">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="depot">Magazino</label>
              <md-select name="depot" v-model="filtri.depot">
                  <md-option value="0">Tutti</md-option>
                  <md-option value="1">Goriziana</md-option>
                  <md-option value="2">Klaut</md-option>
                  <md-option value="3">Mar</md-option>
                  <md-option value="4">K-Marmi</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-10">
            <md-field>
              <label for="sap">SAP</label>
              <md-input type="text" v-model="filtri.sap" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="elogate">ELOGATE di Carico</label>
              <md-input type="text" v-model="filtri.elogate" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
              <md-field>
                <label for="sap">POS di Carico</label>
                <md-input type="text" v-model="filtri.pos" />
              </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
              <md-field>
                <label for="sap">Num. magazzino di Carico</label>
                <md-input type="text" v-model="filtri.numeroMagazzino" />
              </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
              <md-field>
                <label for="sap">Delivery Note di Carico</label>
                <md-input type="text" v-model="filtri.deliveryNote" />
              </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
          <md-field>
            <label for="sap">Delivery Note di Scarico</label>
            <md-input type="text" v-model="filtri.deliveryNoteScarico" />
          </md-field>
      </div>
        </div>
        <div class="md-layout md-gutter">
            <div class="dateBlock">
                <label for="orderDate">Data di Carico</label>
                <div class="md-layout">
                    <div class="md-layout-item maxwidth220">
                      <md-datepicker v-model="filtri.dateFrom" md-immediately :md-open-on-focus="false">
                          <label for="dateFrom">Da</label>
                      </md-datepicker>
                    </div>
                    <div class="md-layout-item maxwidth220">
                      <md-datepicker v-model="filtri.dateTo" md-immediately :md-open-on-focus="false">
                          <label for="dateTo">A</label>
                      </md-datepicker>
                    </div>
                </div>
            </div>
            <div class="dateBlock">
            <label for="orderDate">Data di Scarico</label>
            <div class="md-layout">
                <div class="md-layout-item maxwidth220">
                  <md-datepicker v-model="filtri.dateScaricoFrom" md-immediately :md-open-on-focus="false">
                      <label for="dateFrom">Da</label>
                  </md-datepicker>
                </div>
                <div class="md-layout-item maxwidth220">
                  <md-datepicker v-model="filtri.dateScaricoTo" md-immediately :md-open-on-focus="false">
                      <label for="dateTo">A</label>
                  </md-datepicker>
                </div>
            </div>
        </div>
            <div class="md-layout-item md-small-size-100 md-size-20">
              <md-checkbox v-model="filtri.giacenza">Escludi giacenze a 0</md-checkbox>
            </div>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button class="md-raised" @click="filter()">Filtra</md-button>
        <md-button class="md-raised" @click="fetchData(true)">Azzera</md-button>
      </md-card-actions>
    </md-card>
    <md-table v-model="rows" md-card class="fullScreen sap-list">
        <md-table-row class="tableHeader">
          <md-table-head>Magazzino</md-table-head>
          <md-table-head>Mat. Number (SAP)</md-table-head>
          <md-table-head>Description</md-table-head>
          <md-table-head>Tot. Caricato</md-table-head>
          <md-table-head>Tot. Scaricato</md-table-head>
          <md-table-head>Giacenza</md-table-head>
          <md-table-head class="action">&nbsp;</md-table-head>
        </md-table-row>
        <template v-for="row in rows">
            <md-table-row>
              <md-table-cell>{{row.depotDesc}}</md-table-cell>
              <md-table-cell>{{row.materialNumber}}</md-table-cell>
              <md-table-cell>{{row.description}}</md-table-cell>
              <!--md-table-cell>{{row.packagingAmount | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
              <md-table-cell>{{row.scaricatoAmount | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
              <md-table-cell>{{row.rimanenzaAmount | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell -->
              <md-table-cell>{{row.carico | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
              <md-table-cell>{{row.scarico | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
              <md-table-cell>{{row.giacenza | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
              <md-table-cell class="action">
                  <md-button class="md-icon-button md-dense" @click="rowDetail(row)">
                    <md-icon>list</md-icon>
                  </md-button>
              </md-table-cell>
            </md-table-row>
          </template>
    </md-table>
    <div style="height:1px;overflow:hidden;">
    <md-table v-model="rows" class="depots-printable">
    <md-table class="fullScreen sap-list">
      <md-table-row class="tableHeader">
        <md-table-head>Magazzino</md-table-head>
        <md-table-head>Mat. Number (SAP)</md-table-head>
        <md-table-head>Description</md-table-head>
        <md-table-head>Tot. Caricato</md-table-head>
        <md-table-head>Tot. Scaricato</md-table-head>
        <md-table-head>Giacenza</md-table-head>
      </md-table-row>
      <template v-for="row in rows">
          <md-table-row>
            <md-table-cell>{{row.depotDesc}}</md-table-cell>
            <md-table-cell>{{row.materialNumber}}</md-table-cell>
            <md-table-cell>{{row.description}}</md-table-cell>
            <!--md-table-cell>{{row.packagingAmount | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
            <md-table-cell>{{row.scaricatoAmount | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
            <md-table-cell>{{row.rimanenzaAmount | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell -->
            <md-table-cell>{{row.carico | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
            <md-table-cell>{{row.scarico | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
            <md-table-cell>{{row.giacenza | formatAmount}} / {{row.packagingAmountUnit}}</md-table-cell>
          </md-table-row>
        </template>
    </md-table>
  </md-table>
    </div>
<!--    <md-card>
      <md-card-content>
          <div class="pager">
            <md-button class="md-icon-button" @click="prev()" :disabled="pager.page == 1" v-bind:class="{'md-raised' : pager.page > 1}">
              <md-icon>navigate_before</md-icon>
            </md-button>
            <div class="current">Pag. {{pager.page}}/{{pager.max}}</div>
            <md-button class="md-icon-button" @click="next()" :disabled="pager.page >= pager.max" v-bind:class="{'md-raised' : pager.page < pager.max}">
              <md-icon>navigate_next</md-icon>
            </md-button>
          </div>
      </md-card-content>
    </md-card> -->
    <SAPDetail :depotDesc="depotDesc" :selectedRow="selectedRow" :currentFilters="currentFilters"></SAPDetail>
        
  </div>

</template>

<script>

import moment from 'moment'
import SAPDetail from './SAPDetail.vue'

export default {
  name: 'Depots',
  components: {
      SAPDetail
  },
  data: () => ({
    rows: [],
    showSAPDetailDialog: false,
    depotDesc: '',
    selectedRow: { 
        materialNumber : '',
        description : '',
//        data: {
//            'ingressi' : [],
//            'uscite' : [],
//        }
    },
    jsonData : null,
    depots: {},
    currentFilters : {},
    filtri: {
      depot: 0,
      sap : '',
      elogate: '',
      dateFrom : null,
      dateTo : null,
      dateScaricoFrom : null,
      dateScaricoTo : null,
      giacenza: true,
      pos : '',
      numeroMagazzino : '',
      deliveryNote : '',
      deliveryNoteScarico : ''
    },
    pager: {
      page : 1,
      max : 1
    }
  }),
  mounted() {
    this.depots = window.appCfg.depots
    this.fetchData()
  },
  methods: {
    next() {
      this.pager.page = Math.min(++this.pager.page, this.pager.max)
      this.fetchData()
    },
    prev() {
      this.pager.page = Math.max(--this.pager.page, 1)
      this.fetchData()
    },
    filter() {
      this.pager =  {
        page : 1,
        max : 1
      }
      this.fetchData()
    },
    rowDetail(row) {
        let loading = this.$loading.show()
        let pars = { action: 'data', sap: row.materialNumber, depot : row.depot }
        if (this.filtri.elogate != undefined && this.filtri.elogate != '') pars.elogate = this.filtri.elogate
        if (this.filtri.pos != undefined && this.filtri.pos != '') pars.pos = this.filtri.pos
        if (this.filtri.numeroMagazzino != undefined && this.filtri.numeroMagazzino != '') pars.numeroMagazzino = this.filtri.numeroMagazzino
        if (this.filtri.deliveryNote != undefined && this.filtri.deliveryNote != '') pars.deliveryNote = this.filtri.deliveryNote
        if (this.filtri.deliveryNoteScarico != undefined && this.filtri.deliveryNoteScarico != '') pars.deliveryNoteScarico = this.filtri.deliveryNoteScarico
        if (this.filtri.dateFrom != undefined && this.filtri.dateFrom != null) pars.dateFromFormatted = this.filtri.dateFrom != null ? moment(String(this.filtri.dateFrom)).format('YYYY-MM-DD') : ''
        if (this.filtri.dateTo != undefined && this.filtri.dateTo != null) pars.dateToFormatted = this.filtri.dateTo != null ? moment(String(this.filtri.dateTo)).format('YYYY-MM-DD') : ''
        if (this.filtri.dateScaricoFrom != undefined && this.filtri.dateScaricoFrom != null) pars.dateScaricoFromFormatted = this.filtri.dateScaricoFrom != null ? moment(String(this.filtri.dateScaricoFrom)).format('YYYY-MM-DD') : ''
        if (this.filtri.dateScaricoTo != undefined && this.filtri.dateScaricoTo != null) pars.dateScaricoToFormatted = this.filtri.dateScaricoTo != null ? moment(String(this.filtri.dateScaricoTo)).format('YYYY-MM-DD') : ''
        this.depotDesc = this.depots[row.depot]
        this.selectedRow = row
        this.currentFilters = this.filtri
        
        this.$http
          .post(
            '/data/depots',
            pars,
            { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
          )  .then(response => {
            loading.hide()
            let data = row;
            data.data = response.data.data 
            this.$modal.show(SAPDetail, {sap: data})
//            this.editSAPData = row
//            this.editSAPData.data = response.data.data 
//            this.showSAPDetailDialog = true
         })
    },
    exportData(){
      let loading = this.$loading.show()
      this.filtri.dateToFormatted = this.filtri.dateTo != null ? moment(String(this.filtri.dateTo)).format('YYYY-MM-DD') : ''
      this.filtri.dateFromFormatted = this.filtri.dateFrom != null ? moment(String(this.filtri.dateFrom)).format('YYYY-MM-DD') : ''
      this.filtri.dateScaricoToFormatted = this.filtri.dateScaricoTo != null ? moment(String(this.filtri.dateScaricoTo)).format('YYYY-MM-DD') : ''
      this.filtri.dateScaricoFromFormatted = this.filtri.dateScaricoFrom != null ? moment(String(this.filtri.dateScaricoFrom)).format('YYYY-MM-DD') : ''
              
      this.$http
        .post(
          '/data/depots',
          { action: 'export', filters: this.filtri },
          { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
        )  .then(response => {
          this.jsonData = response.data.data
        })  .then(() => {
          loading.hide()
          this.$refs.dlMagazzinoBtn.$el.click()
        })
    },
    printList() {
        
        document.getElementById('print-container').innerHTML = document.querySelector('.depots-printable').innerHTML
        printJS({ printable: 'print-container', type: 'html', documentTitle: 'Magazzino', header: '' , targetStyle : ['border','padding','padding-right','padding-left','display', 'max-width', 'width','border-top-color','border-top-style','border-top-width','border-right-color','border-right-style','border-right-width','border-bottom-color','border-bottom-style','border-bottom-width','border-left-color','border-left-style','border-left-width','border-image-outset','border-image-repeat','border-image-slice','border-image-source','border-image-width']})
    },
    async fetchData(reset) {
        
      this.showSAPDetailDialog = false
      
      if (reset) {
        this.filtri = {
          depot: 0,
          sap : '',
          elogate:'',
          dateTo :  null,
          dateFrom : null,
          dateScaricoTo :  null,
          dateScaricoFrom : null,
          giacenza:true,
          pos : '',
          numeroMagazzino : '',
          deliveryNote : '',
          deliveryNoteScarico : ''
        }
        this.pager =  {
          page : 1,
          max : 1
        }
      }
      let loading = this.$loading.show();

      this.filtri.dateToFormatted = this.filtri.dateTo != null ? moment(String(this.filtri.dateTo)).format('YYYY-MM-DD') : ''
      this.filtri.dateFromFormatted = this.filtri.dateFrom != null ? moment(String(this.filtri.dateFrom)).format('YYYY-MM-DD') : ''
      this.filtri.dateScaricoToFormatted = this.filtri.dateScaricoTo != null ? moment(String(this.filtri.dateScaricoTo)).format('YYYY-MM-DD') : ''
      this.filtri.dateScaricoFromFormatted = this.filtri.dateScaricoFrom != null ? moment(String(this.filtri.dateScaricoFrom)).format('YYYY-MM-DD') : ''
              
      try {
        const params = { action: 'list' , filters : this.filtri, page : this.pager.page}
        const response = await this.$http.post('/data/depots', params, {
          headers: { Authorization: 'Bearer ' + this.$cookie.get('token') }
        })
        loading.hide()
        if (!response.data.done) {
          this.pager =  {
            page : 1,
            max : 1
          }
          this.$fire({
            html: response.data.message,
            type: 'error'
          }).then(r => {
            if (response.data.bu != '') this.$router.push(response.data.bu)
          })
          return
        }
        this.rows = response.data.data
        this.pager = response.data.pager
      } catch (err) {
        loading.hide()
        if (err.response) {
          this.$fire({
            text: 'Server error: ' + err,
            type: 'error'
          })
        } else if (err.request) {
          this.$fire({
            text: 'Network error: ' + err,
            type: 'error'
          })
        } else {
          this.$fire({
            text: 'System error: ' + err,
            type: 'error'
          })
        }
      }
    }
  }
}

</script>

<style lang="css" scoped>

  .md-table + .md-table {
    margin-top: 16px;
  }
  .md-checkbox {width:100%;}
  @media print {
      .md-toolbar, .filtri {display: none;}
      .action {display:none; width:1px;max-width:1px;}
      .action .md-table-cell-container, .action .md-table-cell-container .md-icon {display:none;}

  }
</style>



// WEBPACK FOOTER //
// src/components/Depots.vue